

class Asset {

    constructor(balance, name, color = "#ffffff") {
        this.balance = balance;
        this.name = name;
        this.color = color;
    }

    getAssets() {
        let _assets = []
        _assets.push({
            balance: this.balance,
            name: this.name,
            color: this.color

        });
        return _assets;
    }

}

module.exports = Asset;
